import { startBootLoader } from './boot.ts';

// Standalone build entry, injected into index.html by vite-plugins/boot-loader.ts. It must not
// import anything the app imports: a shared module would land in a chunk this entry waits on,
// defeating the point of running first. The work lives in boot.ts, testable without this call.
startBootLoader();
